import React, { useContext } from 'react'
import { arrayOf, bool, number, oneOfType, shape, string } from 'prop-types'
import * as Styled from './MinAmountRegulation.styles'
import DOMPurify from 'dompurify'

// component stack
import { TextBox, Tooltip } from 'components/atoms'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'

const MinAmountRegulation = ({ data }) => {
  const { text, permissionText, tooltip, tableData } = data
  const textContext = useContext(TextContext)

  // filter data with zero values (MGMNAVSUP-448)
  const validTableData = tableData.filter((item) => item.amount !== 0)

  return (
    <TextBox title={ textContext['minAmountRegulation.title'] }>
      <Styled.MinAmountRegulation>
        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}></p>
        <p>
          {permissionText && permissionText}
          <Tooltip
            arrow='left'
            className='tooltip'
            dialogTitle={ tooltip.title }
            infoIconId='minimum-amount-regulation-info-icon'
            tooltipId='minimum-amount-regulation-tooltip'>
            {tooltip.tip}
          </Tooltip>
        </p>
        {validTableData.length > 0 && (
          <>
            <table>
              <thead>
                <tr>
                  <th>{textContext['minAmountRegulation.table.timeRange']}</th>
                  <th>{textContext['minAmountRegulation.table.Amount']}</th>
                </tr>
              </thead>
              <tbody>
                {validTableData.map((row, index) => (
                  <tr key={ index }>
                    <td>{row.timeRange}</td>
                    <td>{row.amount}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {/* <div className="table-footer">*/}
            {/*    <p>{textContext['minAmountRegulation.table.moreInformation']} </p>*/}
            {/*    <Link id="3" to={moreInformationLink} className="external-link">{moreInformationLink}</Link>*/}
            {/* </div>*/}
          </>
        )}
      </Styled.MinAmountRegulation>
    </TextBox>
  )
}

MinAmountRegulation.propTypes = {
  data: shape({
    text: string.isRequired,
    permissionText: oneOfType([string, bool]),
    tooltip: shape({
      tip: string.isRequired,
      title: string.isRequired,
    }),
    tableData: arrayOf(
      shape({
        timeRange: string.isRequired,
        amount: number.isRequired,
      })
    ),
    moreInformationLink: string,
  }).isRequired,
}

export default MinAmountRegulation
